import { render } from "./VirtualRedTagNotificationConfirmed.vue?vue&type=template&id=f6d073ae&scoped=true&ts=true"
import script from "./VirtualRedTagNotificationConfirmed.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagNotificationConfirmed.vue?vue&type=script&lang=ts"

import "./VirtualRedTagNotificationConfirmed.vue?vue&type=style&index=0&id=f6d073ae&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d073ae"]])

export default __exports__